import API from 'app/utils/apiClient';

const likeToggle = (objectType, objectId) =>
  API.post('/like-toggle/', { objectType, objectId });

export default {
  likeToggle,
};



// WEBPACK FOOTER //
// ./src/app/apis/common.js